
export interface ShoppingCartState {
    loading: boolean;
    error: boolean;
    errorMessage: string;
    suggested: ShoppingCartSuggested;
}

/** Error de inputs por producto (precio y cantidad por separado). */
export interface ProductInputErrors {
    price: boolean;
    quantity: boolean;
}

/** Estado de selección del carrito comercial (qué eligió el usuario de lo sugerido). */
export interface CommercialCartSelection {
    selectedByProductId: Record<number, boolean>;
    quantityByProductId: Record<number, number>;
    priceByProductId: Record<number, number>;
    /** Errores de validación de inputs por producto. */
    inputErrorByProductId: Record<number, ProductInputErrors>;
    /** Meses seleccionados (1-6). null = ninguno seleccionado. */
    selectedMonths: number | null;
    /** Método de pago (valor enviado como Payment-Method al endpoint). null = ninguno seleccionado. */
    selectedPaymentMethod: number | null;
}

export const initialCommercialCartSelection: CommercialCartSelection = {
    selectedByProductId: {},
    quantityByProductId: {},
    priceByProductId: {},
    inputErrorByProductId: {},
    selectedMonths: null,
    selectedPaymentMethod: null,
};

export interface ShoppingCartSuggested {
    products: Products;
    users: User;
    user_profile: UserProfile;
    success: boolean;
    /** Selección del usuario en el carrito comercial (no viene del API). */
    selection: CommercialCartSelection;
}

export interface Discount {
    discount: number;
    volumen: number;
}
export interface Products {
    category: CategoryProducts;
}
export interface ProductByCategory {
    product_id: number;
    name_product: string;
    price: number;
    discount: number | null;
    description: string;
    category: string;
    subcategory: string;
}

export interface CategoryProducts {
    Destacado: ProductByCategory[];
    Leads: ProductByCategory[];
    smart_leads: ProductByCategory[];
    premium: ProductByCategory[];
}


export interface PropertiesForCategory {
    alta?: number;
    media?: number;
    baja?: number;
}
export interface PropertiesForCategoryHighlighted {

    alta?: number;
    media?: number;
    baja?: number;
}
export interface User {
    email: string;
    user_id: number;
}

export interface FreemiumStateLeads {
    used: number;
    limit: number;
}

export interface FreemiumStatePeriod {
    days_left_premium: number | null;
    days_until_penalty_ends: number | null;
}

export interface FreemiumState {
    plan: "freemium" | "premium";
    is_blocked: boolean;
    leads: FreemiumStateLeads;
    period: FreemiumStatePeriod;
}

export interface ContactPhone {
    phone: string | null;
    country_code: string | null;
}

export interface UserProfile {
    name: string;
    lastname: string;
    user_created_at: string;
    broker_type: string;
    active_properties: number;
    highlighted_properties: number;
    total_active_slots: number;
    freemium_state: FreemiumState | null;
    contact_phone: ContactPhone;
}

export const initialShoppingCart: ShoppingCartState = {
    loading: false,
    error: false,
    errorMessage: '',
    suggested: {
        products: {
            category: {
                Destacado: [],
                Leads: [],
                smart_leads: [],
                premium: []
            }
        },
        users: {
            email: "",
            user_id: 0
        },
        user_profile: {
            name: '',
            lastname: '',
            user_created_at: '',
            broker_type: '',
            active_properties: 0,
            highlighted_properties: 0,
            total_active_slots: 0,
            freemium_state: null,
            contact_phone: {
                phone: null,
                country_code: null,
            },
        },
        success: false,
        selection: initialCommercialCartSelection
    }
};
